import { withRouter, Link } from "react-router-dom";

import { Row, Card, Col, ListGroup, Badge, Tab } from "react-bootstrap";

///////////////////////////
import PerfectScrollbar from 'react-perfect-scrollbar'
//////////////////////////

import axios from 'axios';
import React, { useEffect, useState, Fragment } from 'react';
import NumberFormat from 'react-number-format';

import { makeStyles } from '@mui/styles';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import ListItemText from '@material-ui/core/ListItemText';
import ListItem from '@material-ui/core/ListItem';
import List from '@material-ui/core/List';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import IconButton from '@material-ui/core/IconButton';
import Typography from '@material-ui/core/Typography';
import CloseIcon from '@material-ui/icons/Close';
import Slide from '@material-ui/core/Slide';

import InputLabel from '@material-ui/core/InputLabel';
import FormHelperText from '@material-ui/core/FormHelperText';
import FormControl from '@material-ui/core/FormControl';
import Select from '@material-ui/core/Select';

import numeral from 'numeral'


import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { ptBR } from "date-fns/locale";
import DateFnsUtils from '@date-io/date-fns';

//actions
import totalVendasPorVendedorPorData from '../../actions/relatorios/total-vendas-vendedor-e-data';
import pedidosByVendedor from '../../actions/relatorios/lista-pedidos-by-vendedor';



// componemts
import VendasTotalVendido from '../../components/Vendas/VendasTotalVendido';
import CardListaPedidos from '../../components/Vendas/CardListaPedidos';

//functions

import { getDataUsuario } from '../../services/auth'

import {
  Grid,
  Divider,
  Box,
  Avatar
} from '@material-ui/core';

import { useHistory } from "react-router-dom";

import { FiSearch, FiShoppingBag, FiList } from 'react-icons/fi';

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});


const cardSx = {
  p: { xs: 2.5, md: 3 },
  borderRadius: 2.5,
  border: '1px solid',
  borderColor: 'grey.200',
  boxShadow: '0 1px 3px rgba(0,0,0,0.06)',
  bgcolor: '#fff',
};

const sectionAvatarSx = {
  width: 36,
  height: 36,
  bgcolor: '#e8eaf0',
  color: '#1a1a2e',
};

const sectionTitleSx = {
  fontWeight: 700,
  fontSize: '1rem',
};

const buttonSx = {
  bgcolor: '#1a1a2e',
  color: '#fff',
  textTransform: 'none',
  fontWeight: 600,
  borderRadius: 1.5,
  '&:hover': {
    bgcolor: '#16213e',
  },
};

const inputSx = {
  '& .MuiOutlinedInput-root': {
    borderRadius: 6,
    '&.Mui-focused fieldset': {
      borderColor: '#1a1a2e',
    },
  },
  '& .MuiInputLabel-root.Mui-focused': {
    color: '#1a1a2e',
  },
};


function VendasPage(props) {

  const [inicio, setInicio] = React.useState(new Date());
  const [final, setFinal] = React.useState(new Date());

  const [mes, setMes] = React.useState('03');
  const [ano, setAno] = React.useState('2022');

  const [vendasVendedor, setVendasVendedor] = React.useState('');
  const [listaVendas, setListaVendas] = useState([])
  const [key, setKey] = useState(0);

  const buscarMetricas = () => {
    totalVendasPorVendedorPorData({ cpf: getDataUsuario().cpf, inicio: inicio, fim: final })
      .then(res => {
        setVendasVendedor(res.data.vendas);
      }).catch(e => console.log(e));


    pedidosByVendedor({ cpf: getDataUsuario().cpf, inicio: inicio, fim: final })
      .then(res => {
        setListaVendas(res.data);
      }).catch(e => console.log(e));
  }

  useEffect(() => {
    buscarMetricas();
  }, []);



  const handleChangeInicio = (date) => {
    setInicio(date);
  };

  const handleChangeFinal = (date) => {
    setFinal(date);
  };



  return (
    <Box sx={{ bgcolor: '#f5f5f5', minHeight: '100vh' }}>
      {/* Header */}
      <Box sx={{ bgcolor: '#fff', borderBottom: '1px solid #e5e5e5' }}>
        <Box sx={{ maxWidth: '98%', mx: 'auto', py: 2 }}>
          <Typography sx={{ fontWeight: 700, fontSize: '1.25rem', color: '#1a1a2e' }}>
            Vendas
          </Typography>
        </Box>
      </Box>

      {/* Content */}
      <Box sx={{ maxWidth: '98%', mx: 'auto', py: 3 }}>
        <Grid container spacing={3}>

          {/* Filter Card */}
          <Grid item md={12} xs={12}>
            <Box sx={cardSx}>
              <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5, mb: 2.5 }}>
                <Avatar sx={sectionAvatarSx}>
                  <FiSearch size={18} />
                </Avatar>
                <Typography sx={sectionTitleSx}>Filtrar por Periodo</Typography>
              </Box>
              <Grid container alignItems="center" spacing={2}>
                <Grid item md={3} sm={4} xs={12}>
                  <DatePicker
                    disableToolbar
                    variant="inline"
                    format="dd/MM/yyyy"
                    margin="normal"
                    id="date-picker-inline"
                    label="Data inicial"
                    value={inicio}
                    onChange={handleChangeInicio}
                    KeyboardButtonProps={{
                      'aria-label': 'change date',
                    }}
                    sx={inputSx}
                  />
                </Grid>
                <Grid item md={3} sm={4} xs={12}>
                  <DatePicker
                    disableToolbar
                    margin="normal"
                    variant="inline"
                    id="date-picker-inline"
                    label="Data final"
                    format="dd/MM/yyyy"
                    value={final}
                    onChange={handleChangeFinal}
                    KeyboardButtonProps={{
                      'aria-label': 'change date',
                    }}
                    sx={inputSx}
                  />
                </Grid>
                <Grid item md={2} sm={4} xs={12}>
                  <Button
                    onClick={buscarMetricas}
                    variant="contained"
                    disableElevation
                    style={{
                      backgroundColor: '#1a1a2e',
                      color: '#fff',
                      textTransform: 'none',
                      fontWeight: 600,
                      borderRadius: 6,
                      padding: '10px 24px',
                    }}
                  >
                    Pesquisar
                  </Button>
                </Grid>
              </Grid>
            </Box>
          </Grid>

          {/* PDV Summary Card */}
          <Grid item md={4} sm={12} xs={12}>
            <Box sx={cardSx}>
              <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5, mb: 2.5 }}>
                <Avatar sx={sectionAvatarSx}>
                  <FiShoppingBag size={18} />
                </Avatar>
                <Typography sx={sectionTitleSx}>PDV</Typography>
              </Box>

              <Typography sx={{ fontSize: '0.85rem', color: 'text.secondary', fontWeight: 600, mb: 2 }}>
                Vendas
              </Typography>

              <Grid container spacing={2}>
                <Grid item md={6} sm={6} xs={12}>
                  <VendasTotalVendido
                    titulo={"Total Vendas"}
                    valor={vendasVendedor ? numeral(vendasVendedor.totalProdutos).format('0,0.00') : 0}
                  />
                </Grid>

                <Grid item md={6} sm={6} xs={12}>
                  <VendasTotalVendido
                    titulo={"Quantidade Vendas"}
                    valor={vendasVendedor ? vendasVendedor.totalPedidos : 0}
                  />
                </Grid>
              </Grid>
            </Box>
          </Grid>

          {/* Sales List Card */}
          <Grid item md={8} sm={12} xs={12}>
            <Box sx={cardSx}>
              <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5, mb: 2.5 }}>
                <Avatar sx={sectionAvatarSx}>
                  <FiList size={18} />
                </Avatar>
                <Typography sx={sectionTitleSx}>Minhas Vendas</Typography>
              </Box>

              <Box sx={{ maxHeight: 400, overflowY: 'auto', pr: 1 }}>
                {listaVendas.map((res, index) => (
                  <Box key={index} sx={{ mb: 1.5 }}>
                    <CardListaPedidos
                      dataPedido={res}
                      pedido={res.number}
                      frete={res.shipping_price}
                      valor={res.items}
                      status={res.status}
                      cliente={res.first_name}
                      data={res.date_created}
                      pago={res.paid === true ? "Sim" : "Não"}
                    />
                  </Box>
                ))}
              </Box>
            </Box>
          </Grid>

        </Grid>
      </Box>
    </Box>
  )
}
export default withRouter(VendasPage)
